'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/call-bind/~/function-bind/index.js
// module id = 847
// module chunks = 0